var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "check-box-wrapper"
  }, [_c('label', {
    attrs: {
      "for": "checkbox",
      "title": _vm.checkboxItem.name
    }
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(" " + _vm._s(_vm.checkboxItem.name) + " ")]), _vm._v(" -"), _c('span', {
    staticClass: "price"
  }, [_vm._v(" $" + _vm._s(_vm.checkboxItem.price) + " ")])]), _c('input', {
    staticClass: "ms-2",
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "value": _vm.checkboxItem.value,
      "checked": _vm.checked
    },
    on: {
      "change": _vm.handleChange
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }